'use client';

import { createContext } from 'react';

import type { DrawNumber } from '../../../../../schema/draw/entry.js';
import type { ProductConstraint, SubProduct } from '../../../../../schema/product/entry.js';
import type { EventNumber } from '../../../../../schema/sport/entry.js';

export type DrawContext = {
  product: ProductConstraint & {
    subProduct?: SubProduct;
  };
  drawNumber?: DrawNumber;
  eventNumber: EventNumber;
};

/**
 * Draw context used to determine the active draw based on the current draw number, product and event number.
 */
export const DrawContext = createContext<DrawContext | undefined>(undefined);
